import React, { useState } from 'react';

// import components
import FeatureVideo from 'components/partials/feature-video';
import VideoModal from 'components/partials/parts/video-modal';

// import helpers
import { isGatsbyImageData } from 'helpers/is-gatsby-image';

// import types
import { VideoData } from 'types/video-data';

const FeaturedVideoLargeBuilder: React.FC<{ featuredVideoLargeData?: Queries.FeaturedVideoLargeBlockFragment }> = ({ featuredVideoLargeData }) => {

    if (!featuredVideoLargeData) return null;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleVideoClick = () => {

        setIsModalOpen(true);

    };

    let image = isGatsbyImageData(featuredVideoLargeData.video?.thumbnailImageOverride?.featuredVideoCard) ? featuredVideoLargeData.video.thumbnailImageOverride?.featuredVideoCard : undefined;

    let imageOverride = {
        image: image, 
        alt: featuredVideoLargeData.video?.thumbnailImageOverride?.alt ?? '',
        thumbnailUrl: undefined,
        thumbnailHeight: undefined,
        thumbnailWidth: undefined,
    };

    let thumbnailFallback = {
        image: undefined, 
        alt: featuredVideoLargeData.video?.title ?? '',
        thumbnailUrl: featuredVideoLargeData.video?.externalVideoLink?.thumbnailUrl ?? undefined,
        thumbnailHeight: featuredVideoLargeData.video?.externalVideoLink?.height ?? undefined,
        thumbnailWidth: featuredVideoLargeData.video?.externalVideoLink?.width ?? undefined,
    };

    // Use imageOverride if image is defined, otherwise use thumbnailFallback
    let thumbnailData = image ? imageOverride : thumbnailFallback;

    // Use title override from Dato, or external video title otherwise
    let title = featuredVideoLargeData.video?.title || featuredVideoLargeData.video?.externalVideoLink?.title || 'Error: No Title';

    const videoData: VideoData = {
        id: featuredVideoLargeData.video?.id ?? '',
        url: featuredVideoLargeData.video?.externalVideoLink?.url ?? '',
        type: featuredVideoLargeData.video?.externalVideoLink?.provider ?? '',
        title: title,
    };

    return (
        <>
            <FeatureVideo
                url={featuredVideoLargeData.video?.externalVideoLink?.url ?? ''}
                image={thumbnailData.image}
                thumbnailUrl={thumbnailData.thumbnailUrl}
                thumbnailHeight={thumbnailData.thumbnailHeight}
                thumbnailWidth={thumbnailData.thumbnailWidth}
                alt={thumbnailData.alt}
                onPlayButtonClick={handleVideoClick}
            />
            <VideoModal videoData={videoData} isOpen={isModalOpen} closeModal={() => { setIsModalOpen(false) }} />
        </>
    );
};

export default FeaturedVideoLargeBuilder;